module.exports = __webpack_public_path__ + "static/images/alipay.jhnOHTQ.svg";